import {
  Chip as MuiChip,
  type ChipProps as MuiChipProps,
  type SxProps,
  type Theme,
} from '@mui/material';

export interface ChipProps extends Omit<MuiChipProps, 'size'> {
  size?: MuiChipProps['size'] | 'xs';
}

const xsSx: SxProps<Theme> = {
  height: 18,
  fontWeight: 600,
  letterSpacing: '0.25px',
  '& .MuiChip-label': {
    px: 0.75,
    fontSize: '0.6875rem',
    lineHeight: 1,
  },
  '& .MuiChip-icon, & .MuiChip-avatar': {
    width: 12,
    height: 12,
    fontSize: 12,
    ml: 0.5,
    mr: -0.25,
  },
  '& .MuiChip-deleteIcon': {
    fontSize: 12,
    mr: 0.5,
    ml: -0.25,
  },
};

const Chip = ({ size, sx, ...props }: ChipProps) => {
  if (size !== 'xs') {
    return <MuiChip size={size} sx={sx} {...props} />;
  }
  return (
    <MuiChip
      size="small"
      sx={[xsSx, ...(sx ? (Array.isArray(sx) ? sx : [sx]) : [])]}
      {...props}
    />
  );
};

export default Chip;
